import { RequestOptions } from '../api/DNAApolloClient/DNAApolloClient';
import { ErrorResponseType, ValidationResultItem } from '../typings/common';

import { getErrorTitle } from './GraphqlErrorHelper/GraphqlErrorHelper';

export class NotSyncedError<T> {
    public data: T;

    constructor(data: T) {
        this.data = data;
    }
}

interface ApiMethodExecutingErrorConstructor {
    message: string;
    errors?: ValidationResultItem[];
    warnings?: ValidationResultItem[];
    errorType?: ErrorResponseType;
    requestOptions?: RequestOptions;
}

export class ApiMethodExecutingError {
    private readonly error: Error;
    private readonly errors: ValidationResultItem[];
    private readonly warnings: ValidationResultItem[];
    private readonly errorType: ErrorResponseType;
    private readonly requestOptions?: RequestOptions;

    constructor(options: ApiMethodExecutingErrorConstructor) {
        this.error = new Error(options.message);
        this.errors = options.errors || [];
        this.warnings = options.warnings || [];
        this.errorType = options.errorType || ErrorResponseType.internal;
        this.requestOptions = options.requestOptions;
    }

    /**
     * @deprecated этот метод будет удален
     * вместо него следует использовать методы getErrors и getWarnings
     * для получения списка всех ошибок. И получить текст ошибки с помощью GraphqlErrorHelper.getErrorMessage
     */
    getMessage(): string {
        return this.error.message;
    }

    getTitle(): string {
        return getErrorTitle();
    }

    getNativeError(): Error {
        return this.error;
    }

    getErrors(): ValidationResultItem[] {
        return this.errors;
    }

    getType(): ErrorResponseType {
        return this.errorType;
    }

    getWarnings(): ValidationResultItem[] {
        return this.warnings;
    }

    getRequestOptions(): RequestOptions | undefined {
        return this.requestOptions;
    }
}
